export default __webpack_public_path__ + "resources/icons/n100-e1f0.png";